class CrossContaminationPointAPI {

  constructor(api, version, name) {
    this.api = api;
    this.version = version;
    this.name = name;
  }

  listCrossContaminationPoints(haccp_plan_pk) {
    if (typeof haccp_plan_pk === 'number') {
      return this.api.get(`${this.version}/cross_contamination_points/?haccp_plan_pk=${haccp_plan_pk}`);
    }

    return this.api.get(`${this.version}/cross_contamination_points/`)
  }

  createCrossContaminationPoint(payload) {
    return this.api.post(`${this.version}/cross_contamination_points/`, payload);
  }

  retrieveCrossContaminationPoint(pk) {
    return this.api.get(`${this.version}/cross_contamination_points/${pk}/`);
  }

  updateCrossContaminationPoint(payload) {
    return this.api.put(`${this.version}/cross_contamination_points/${payload.pk}/`, payload);
  }

  deleteCrossContaminationPoint(pk) {
    return this.api.delete(`${this.version}/cross_contamination_points/${pk}/`);
  }

  selectTemplate(pk, template) {
    return this.api.post(`${this.version}/cross_contamination_points/${pk}/select_template/`, template);
  }

  addHazardToCrossContaminationPoint(cross_contamination_point_pk, hazard) {
    return this.api.post(`${this.version}/cross_contamination_points/${cross_contamination_point_pk}/add_hazard/`, hazard);
  }

  removeHazardFromCrossContaminationPoint(cross_contamination_point_pk, hazard) {
    return this.api.post(`${this.version}/cross_contamination_points/${cross_contamination_point_pk}/remove_hazard/`, hazard);
  }

  getHistory(pk) {
    return this.api.get(`${this.version}/cross_contamination_points/${pk}/get_history/`);
  }
  getRevertedCCP(pk, date) {
    return this.api.post(`${this.version}/cross_contamination_points/${pk}/get_reverted_ccp/`, date);
  }
}


export default CrossContaminationPointAPI;
